export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center">
          关于我们
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">了解色影视平台</p>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-5 gap-8 items-center">
          <div className="lg:col-span-3">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              色影视是一个专注于高清影视内容聚合的免费在线观看平台。自上线以来，我们始终坚持"免费、高清、流畅"的核心理念，为全国影迷提供海量电影、电视剧、综艺、动漫等优质内容。平台资源覆盖动作、喜剧、科幻、悬疑、爱情等全类型题材，同步更新国内外最新热播剧集与院线大片。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              春色影视最新网址入口由本站持续维护发布，确保影迷朋友能够稳定访问。我们采用先进的视频分发技术，支持多线路自动切换，真正做到高清不缓冲、播放不卡顿，无论您是使用电脑、手机还是平板，都能获得一致的流畅观影体验。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <span className="px-3 py-1.5 text-xs font-medium text-primary-700 bg-primary-100 rounded-full">全免费</span>
              <span className="px-3 py-1.5 text-xs font-medium text-accent-700 bg-accent-100 rounded-full">无需注册</span>
              <span className="px-3 py-1.5 text-xs font-medium text-secondary-700 bg-secondary-100 rounded-full">多线路播放</span>
              <span className="px-3 py-1.5 text-xs font-medium text-primary-700 bg-primary-100 rounded-full">每日更新</span>
            </div>
          </div>
          <div className="lg:col-span-2">
            <div className="rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20modern%20living%20room%20with%20large%20TV%20screen%20displaying%20cinematic%20content%2C%20warm%20ambient%20lighting%20from%20floor%20lamp%2C%20comfortable%20sofa%2C%20evening%20atmosphere%2C%20minimal%20interior%20design%2C%20golden%20hour%20tones%2C%20cozy%20home%20theater%20vibe%2C%20soft%20shadows&width=600&height=450&seq=about-cinema-warm&orientation=landscape"
                alt="色影视舒适的观影环境"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}